// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Afji","label":"Section_label__10u4v","contentWrap":"Section_contentWrap__VdEYK","footer":"Section_footer__39BFE","footerInner":"Section_footerInner__1ZqBp"};